module.exports = __webpack_public_path__ + "img/aperture.ceef6901.png";